<template lang="html">
    <div id="manipulators-menu">
        <md-tabs :md-active-tab="activeTab">
            <md-tab id="tab-manipulatorprices" v-bind:to="{ name: 'ManipulatorPrices'}" md-label="Список"></md-tab>
            <md-tab id="tab-settings" v-bind:to="{ name: 'ManipulatorPricesSettings'}" md-label="Настройки"></md-tab>
        </md-tabs>
    </div>
</template>
<script>
    export default {
        name: 'manipulators-menu',
        data() {
            return {
                activeTab: null
            }
        },
        watch: {
            '$route'() {
                this.activeTab = 'tab-' + this.$route.meta.tab;
            }
        },
        created() {
            this.activeTab = 'tab-' + this.$route.meta.tab;
        }
    }
</script>



// WEBPACK FOOTER //
// ManipulatorsMenu.vue?87804bf6